// Canonical internal/partner role set. Lives in the `types` layer so both the
// `config` (nav) and `routes` (guards) layers can share one source of truth —
// `config` may not import from `features`, so the union cannot live in auth.
// The auth zod schema re-uses `ROLES` for `userSchema.role`.
export const ROLES = [
  'super_admin',
  'admin',
  'customer_support_logistics',
  'field_technician',
  'dealer',
] as const;

export type Role = (typeof ROLES)[number];
